import type { ReactNode } from 'react';
import Link, { type LinkProps } from 'next/link';

type CatalogLinkProps = LinkProps & {
  children?: ReactNode;
  className?: string;
  ariaLabel?: string;
};

const CatalogLink = ({
  href,
  children,
  className,
  prefetch = false,
  ariaLabel,
  ...props
}: CatalogLinkProps) => (
  <Link
    href={href}
    prefetch={prefetch}
    className={className}
    aria-label={ariaLabel}
    {...props}
  >
    {children}
  </Link>
);

export default CatalogLink;
